import { useEffect, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import AdminActivityFilter from "./AdminActivityFilter";
import AdminActivityCard from "./AdminActivityCard";
import { errorMessage } from "../../utils/toastify-message/ToastifyMessage";
import moment from "jalali-moment";

export default function AdminActivityList() {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState();

  const getActivities = async (params) => {
    const path = "admin/adminActivities";
    try {
      const response = await getApi({ path, params });
      setData(response.data.result.data || []);
    } catch (error) {
      errorMessage(error.response?.data.errors[0]?.message);
    }
  };

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getActivities(allFilter);
  };

  useEffect(() => {
    getActivities({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex items-center justify-between">
        <h3 className="text-gray-800 dark:text-white text-xl font-semibold">
          فعالیت‌های ادمین‌ها
        </h3>
      </div>
      <div className="border-b border-gray-200 dark:border-gray-700">
        <AdminActivityFilter filterDataHandler={filterDataHandler} />
      </div>
      <div className="flex flex-wrap gap-3 items-center justify-between my-2 mt-4 mr-4">
        <p className="text-sm text-gray-600 dark:text-gray-300">
          تعداد نتایج:{" "}
          <span className="font-semibold">{data?.length || 0}</span>
        </p>
      </div>
      <div className="mt-4 w-full flex flex-col gap-4">
        {data.length > 0 ? (
          data.map((item, index) => {
            return <AdminActivityCard key={index} data={item} />;
          })
        ) : (
          <div className="text-center py-10 text-gray-500 dark:text-gray-400">
            هیچ فعالیتی یافت نشد
          </div>
        )}
      </div>
    </div>
  );
}
